export default {
  data(){
    return{
      isMobile:/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)?true:false
    }
  },
}